module.exports = "/assets/964b422a6c248c832a01988c7198fac0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/C9.png
// module id = 1257
// module chunks = 0